// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1a1rN","bigColWidth":"Table_bigColWidth__1HR8H","biggerColWidth":"Table_biggerColWidth__2Ixfu","row":"Table_row__2QboL","col":"Table_col__3aiiH"};